import {
  GET_COURSE_CATEGORIES,
  EDIT_COURSE_CATEGORIES,
  DELETE_COURSE_CATEGORIES,
  ADD_COURSE_CATEGORY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
  SET_ORDER_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialCourseCategories = {
  courseCategories: [],
  courseCategoriesCount: 0,
  search: "",
  page: 1,
  sortby: "",
  orderby: "desc",
};

const courseCategoriesReducer = (state = initialCourseCategories, action) => {
  switch (action.type) {
    case GET_COURSE_CATEGORIES:
      return {
        ...state,
        courseCategories: action.payload.categories.map((course) => {
          return {
            ...course,

            updatedAtFormatted: moment(course.createdAt).format("ll"),
          };
        }),
        courseCategoriesCount: action.payload.totalCount,
      };

    case EDIT_COURSE_CATEGORIES:
      return {
        ...state,
        courseCategories: state.courseCategories.map((courseCategory) => {
          if (courseCategory.id === action.payload.id) {
            return action.payload;
          } else {
            return courseCategory;
          }
        }),
      };

    case DELETE_COURSE_CATEGORIES:
      return {
        ...state,
        courseCategories: state.courseCategories.filter((courseCategory) => {
          if (courseCategory.id === action.payload.id) {
            return action.payload;
          } else {
            return courseCategory;
          }
        }),
        courseCategoriesCount: (state.courseCategoriesCount -= 1),
      };

    case ADD_COURSE_CATEGORY:
      return {
        ...state,
        courseCategories: state.courseCategories.push(action.payload),
        courseCategoriesCount: (state.courseCategoriesCount += 1),
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };

    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
};

export default courseCategoriesReducer;
